var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$i18n.locale === "pe"
      ? _c(
          "div",
          [
            _c("Message", {
              attrs: {
                message: "",
                icon: "coming_soon_cl.svg",
                "as-card": true,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm.$i18n.locale === "br"
      ? _c(
          "div",
          [
            _c("Message", {
              attrs: {
                message: "",
                icon: "coming_soon_br.svg",
                "as-card": true,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _c("div", [
      _vm.$i18n.locale === "cl"
        ? _c(
            "div",
            { attrs: { id: "reports-content" } },
            [
              _c("Spinner", {
                attrs: { id: "spinner", "is-loading": _vm.isLoading },
              }),
              _c(
                "div",
                { staticClass: "card-item mt-6", attrs: { id: "search-bar" } },
                [
                  _c("div", { staticClass: "item-title" }, [
                    _vm._v(" Certificados SII "),
                  ]),
                  !_vm.isClient
                    ? _c("FindEntitiesInput", {
                        staticClass: "search-component",
                        attrs: {
                          placeholder:
                            "Encuentra certificado por nombre, RUT o email",
                          "is-loading": "isLoading",
                          finder: _vm.finder,
                        },
                        on: {
                          select: function ($event) {
                            return _vm.selectedClient($event)
                          },
                        },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.cleanResults()
                          },
                        },
                      })
                    : _vm._e(),
                  _vm.documentsList.length > 0
                    ? _c(
                        "div",
                        { staticClass: "report-content" },
                        _vm._l(_vm.documentsList, function (document, i) {
                          return _c(
                            "div",
                            {
                              key: document.Key,
                              staticClass: "card-item shadowless report-item",
                              attrs: {
                                set: (_vm.metadata = _vm.getMetadata(
                                  document.Key
                                )),
                              },
                            },
                            [
                              _c("div", { staticClass: "report-item-resume" }, [
                                _vm._m(0, true),
                                _c("div", { staticClass: "report-item-data" }, [
                                  _c("div", { staticClass: "item-title" }, [
                                    _vm._v(" Periodo "),
                                  ]),
                                  _c("div", { staticClass: "item-data" }, [
                                    _vm._v(
                                      " " + _vm._s(_vm.metadata.year) + " "
                                    ),
                                  ]),
                                ]),
                                _c("div", { staticClass: "report-item-data" }, [
                                  _c("div", { staticClass: "item-title" }, [
                                    _vm._v(" Operación "),
                                  ]),
                                  _c("div", { staticClass: "item-data" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.metadata.companyOperationId
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]),
                                _c("div", { staticClass: "report-item-data" }, [
                                  _c("div", { staticClass: "item-title" }, [
                                    _vm._v(" Fecha "),
                                  ]),
                                  _c("div", { staticClass: "item-data" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.dateToFormatedString(
                                            document.LastModified
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]),
                              ]),
                              _c(
                                "div",
                                { staticClass: "report-item-download" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "button is-button-primary is-rounded",
                                      attrs: { id: `document-${i}` },
                                      on: {
                                        click: function ($event) {
                                          return _vm.downloadClientDocument(
                                            _vm.currentUser.user.clientId ||
                                              _vm.clientId,
                                            document.Key
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._m(1, true),
                                      _c("span", [_vm._v(" Descargar ")]),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm.noDocuments
                    ? _c("div", { staticClass: "report-no-content" }, [
                        _vm._m(2),
                        _c("div", { staticClass: "no-document" }, [
                          _vm._v(" No se encontraron documentos. "),
                        ]),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              !_vm.isClient
                ? _c(
                    "div",
                    {
                      staticClass: "card-item",
                      attrs: { id: "sii-1898-block" },
                    },
                    [
                      _c("div", { staticClass: "report-content" }, [
                        _c("div", { staticClass: "item-title" }, [
                          _vm._v(" SII "),
                        ]),
                        _c(
                          "div",
                          { staticClass: "card-item shadowless report-item" },
                          [
                            _vm._m(3),
                            _c("div", { staticClass: "report-item-download" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "button is-button-primary is-rounded",
                                  attrs: { id: "download-report" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.downloadReport(
                                        "2020-76594721.txt",
                                        "sii1898Report"
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._m(4),
                                  _c("span", { staticClass: "button-title" }, [
                                    _vm._v(" Descargar "),
                                  ]),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              !_vm.isClient
                ? _c(
                    "div",
                    { staticClass: "card-item", attrs: { id: "cmf-block" } },
                    [
                      _c("div", { staticClass: "report-content" }, [
                        _c("div", { staticClass: "item-title" }, [
                          _vm._v(" CMF "),
                        ]),
                        _c(
                          "div",
                          { staticClass: "card-item shadowless report-item" },
                          [
                            _c("div", { staticClass: "report-item-resume" }, [
                              _vm._m(5),
                              _c("div", { staticClass: "report-item-data" }, [
                                _c("div", { staticClass: "item-title" }, [
                                  _vm._v(" Período "),
                                ]),
                                _c("div", { staticClass: "item-data" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getGenerateReportDate(
                                          _vm.getCurrentDate()
                                        )
                                      ) +
                                      " "
                                  ),
                                ]),
                              ]),
                            ]),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "report-item-download columns is-multiline",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "two-buttons-col column" },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "button is-button-primary is-rounded",
                                        attrs: { id: "download-report" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.getAuditReportButton()
                                          },
                                        },
                                      },
                                      [
                                        _vm._m(6),
                                        _c(
                                          "span",
                                          { staticClass: "button-title" },
                                          [_vm._v(" Descargar ")]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "two-buttons-col column" },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "button is-button-secondary is-rounded",
                                        attrs: {
                                          "aria-controls": "contentIdForA11y2",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.isOpen = !_vm.isOpen
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "button-title" },
                                          [_vm._v(" Ver historial ")]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "section",
                              { staticClass: "cmf-list" },
                              [
                                _c(
                                  "b-collapse",
                                  {
                                    staticClass: "panel cmf-list",
                                    attrs: {
                                      "aria-id": "contentIdForA11y2",
                                      animation: "slide",
                                    },
                                    model: {
                                      value: _vm.isOpen,
                                      callback: function ($$v) {
                                        _vm.isOpen = $$v
                                      },
                                      expression: "isOpen",
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "panel-block" }, [
                                      _c(
                                        "section",
                                        [
                                          _c(
                                            "b-table",
                                            {
                                              attrs: {
                                                data: _vm.cmfDocumentList,
                                              },
                                            },
                                            [
                                              _vm._l(
                                                _vm.columns,
                                                function (column) {
                                                  return [
                                                    _c(
                                                      "b-table-column",
                                                      _vm._b(
                                                        {
                                                          key: column.id,
                                                          scopedSlots: _vm._u(
                                                            [
                                                              column.searchable &&
                                                              !column.numeric
                                                                ? {
                                                                    key: "searchable",
                                                                    fn: function (
                                                                      props
                                                                    ) {
                                                                      return [
                                                                        _c(
                                                                          "b-input",
                                                                          {
                                                                            staticClass:
                                                                              "search-cmf",
                                                                            attrs:
                                                                              {
                                                                                rounded:
                                                                                  "",
                                                                                placeholder:
                                                                                  "Buscar por fecha",
                                                                                icon: "search",
                                                                                size: "is-small",
                                                                              },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  props
                                                                                    .filters[
                                                                                    props
                                                                                      .column
                                                                                      .field
                                                                                  ],
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      props.filters,
                                                                                      props
                                                                                        .column
                                                                                        .field,
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "props.filters[props.column.field]",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ]
                                                                    },
                                                                  }
                                                                : null,
                                                              {
                                                                key: "default",
                                                                fn: function (
                                                                  props
                                                                ) {
                                                                  return [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          props
                                                                            .row[
                                                                            column
                                                                              .field
                                                                          ]
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            true
                                                          ),
                                                        },
                                                        "b-table-column",
                                                        column,
                                                        false
                                                      )
                                                    ),
                                                  ]
                                                }
                                              ),
                                              _c("b-table-column", {
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (props) {
                                                        return [
                                                          [
                                                            _c(
                                                              "button",
                                                              {
                                                                staticClass:
                                                                  "button is-button-primary is-rounded",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.getAuditReportButton(
                                                                        props
                                                                          .row
                                                                          .Key
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c("b-icon", {
                                                                  attrs: {
                                                                    icon: "download",
                                                                    size: "is-small",
                                                                  },
                                                                }),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "button-title",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " Descargar "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  2204304596
                                                ),
                                              }),
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "report-item-data" }, [
      _c("div", { staticClass: "item-title" }, [_vm._v(" Reporte ")]),
      _c("div", { staticClass: "item-data" }, [
        _vm._v(" Intereses pagados Nº 20 "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "fas fa-download" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "column has-text-centered no-document-icon" },
      [
        _c("img", {
          attrs: { src: require("@/ui/assets/img/document-not-found.svg") },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "report-item-resume" }, [
      _c("div", { staticClass: "report-item-data" }, [
        _c("div", { staticClass: "item-title" }, [_vm._v(" Reporte ")]),
        _c("div", { staticClass: "item-data" }, [
          _vm._v(" Declaraciones Juradas 1898 "),
        ]),
      ]),
      _c("div", { staticClass: "report-item-data" }, [
        _c("div", { staticClass: "item-title" }, [_vm._v(" Periodo ")]),
        _c("div", { staticClass: "item-data" }, [_vm._v(" 2020 ")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "fas fa-download" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "report-item-data" }, [
      _c("div", { staticClass: "item-title" }, [_vm._v(" Reporte ")]),
      _c("div", { staticClass: "item-data" }, [
        _vm._v(" Mutuos en administración "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "fas fa-download" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }